namespace GeniuzPOS.Product {
    export enum PluTypeFg {
        normal = 1,
        open = 2,
        Weighted = 3
    }
    Serenity.Decorators.registerEnumType(PluTypeFg, 'GeniuzPOS.Product.PluTypeFg');
}
